export default __webpack_public_path__ + "static/media/ruinedblight.40619ab2.png";